import produce from "immer";
import isUndefined from "lodash/isUndefined";

import {
    CHECKLIST_SAVE_ITEM,
    CHECKLIST_REMOVE_ITEM,
    CHECKLIST_ADD_ITEM,
    CHECKLIST_CLEAR_STATE,
    CHECKLIST_SAVE_LABEL,
    CHECKLIST_SAVE_DESCRIPTION,
    CHECKLIST_SET_CURRENT_STATE,
    CHECKLIST_SET_CHECKLISTS,
    CHECKLIST_SET_MODE,
    CHECKLIST_SET_CHECKLIST,
    CHECKLIST_SAVE_CHECKLIST,
    CHECKLIST_SELECT_CHECKLIST,
    CHECKLIST_SET_LOADING,
    CHECKLIST_SET_CURRENT_CHECKLIST,
    CHECKLIST_REORDER_ITEMS
} from "../types";

const initialState = {
    checklists: [],
    initialChecklist: { label: "", description: "", items: [{ label: "Item 1", type: "CHECKBOX" }] },
    checklist: { label: "", description: "", items: [{ label: "Item 1", type: "CHECKBOX" }] },
    currentState: 1,
    mode: "",
    loading: true
};

const mapChecklistItems = (items, keepError = true) => {
    return items.map(({ label, error, type, position }, index) => {
        const nextPosition = typeof position === "number" ? position : index + 1;
        return {
            label,
            type,
            sequenceNumber: index + 1,
            position: nextPosition,
            ...(keepError ? { error } : {})
        };
    });
};

const checklistReducer = produce((draft, action) => {
    switch (action.type) {
        case CHECKLIST_SET_LOADING: {
            draft.loading = action.loading;
            break;
        }
        case CHECKLIST_SET_CHECKLISTS: {
            draft.checklists = action.checklists;
            break;
        }
        case CHECKLIST_SELECT_CHECKLIST: {
            const { checklist } = action;
            draft.checklists = draft.checklists.map((ch) => {
                if (ch.id === checklist.id) {
                    return { ...ch, selected: !isUndefined(checklist.selected) ? undefined : true };
                }
                return { ...ch, selected: undefined };
            });
            break;
        }
        case CHECKLIST_SAVE_CHECKLIST: {
            const { checklist } = action;
            const index = draft.checklists.findIndex((ch) => ch.id === checklist.id);
            if (index >= 0) {
                draft.checklists[index] = checklist;
            }
            break;
        }
        case CHECKLIST_SET_CURRENT_CHECKLIST: {
            draft.checklist = action.checklist;
            break;
        }
        case CHECKLIST_SET_CHECKLIST: {
            draft.initialChecklist = action.checklist;
            draft.checklist = action.checklist;
            break;
        }
        case CHECKLIST_SAVE_LABEL: {
            draft.checklist.label = action.label;
            break;
        }
        case CHECKLIST_SAVE_DESCRIPTION: {
            draft.checklist.description = action.description;
            break;
        }
        case CHECKLIST_ADD_ITEM: {
            const nextItems = [...draft.checklist.items, action.item];
            draft.checklist.items = mapChecklistItems(nextItems);
            break;
        }
        case CHECKLIST_SAVE_ITEM: {
            const nextItems = [...draft.checklist.items];
            nextItems.splice(action.index, 1, action.item);
            draft.checklist.items = mapChecklistItems(nextItems);
            break;
        }
        case CHECKLIST_REMOVE_ITEM: {
            const nextItems = [...draft.checklist.items];
            nextItems.splice(action.index, 1);
            draft.checklist.items = mapChecklistItems(nextItems, false);
            break;
        }
        case CHECKLIST_REORDER_ITEMS: {
            const { fromIndex, toIndex } = action;
            const items = [...draft.checklist.items];

            if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0
                || fromIndex >= items.length || toIndex >= items.length) {
                break;
            }

            const [moved] = items.splice(fromIndex, 1);
            items.splice(toIndex, 0, moved);

            draft.checklist.items = items.map(({ label, error, type }, index) => ({
                label,
                error,
                type,
                sequenceNumber: index + 1,
                position: index + 1
            }));
            break;
        }
        case CHECKLIST_CLEAR_STATE: {
            return initialState;
        }
        case CHECKLIST_SET_CURRENT_STATE: {
            draft.currentState = action.currentState;
            break;
        }
        case CHECKLIST_SET_MODE: {
            draft.mode = action.mode;
            break;
        }
        default:
            return;
    }
}, initialState);

export default checklistReducer;
